import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const TextWrapper = styled(Grid)`
  max-width: 250px;
`;

export const MetricWrapper = styled(Grid)`
  max-width: 250px;

  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x3spacePx / 2}px;
`;
